import { useEffect } from 'react';

export const useVPNStatus = (getSupportConnectionRequest) => {
    useEffect(() => {
        const timer = setInterval(() => getSupportConnectionRequest(), 30e4);

        return () => clearInterval(timer);
    }, []);
};
